export class FamilyDeviceTokenError extends Error {
  constructor(message = 'Family device token invalid') {
    super(message);
    this.name = 'FamilyDeviceTokenError';
  }
}
